<template>
<aside class="sidebar active">
    <div class="nav-container">
        <ul id="slide-out" class="navigation-bar">

            <li class="navigation-bar__item  d-flex align-items-center justify-content-between navigation-bar__item--header p-4">
                <a href="/">
                    <img src="/assets/img/logo.png" alt="Digital solutions" class="imgLogoNav" />
                </a>
                <button type="button" class="sidenav-close">
                    <img src="/assets/img/svg/close.svg" alt="Imagen de una equis">
                </button>
            </li>

            <li v-for="(arr, i) in api_routes" :key="i" :class="global_route === arr.group ? 'active-route' : ''" class="navigation-bar__item" @click="arr.children.length ? toggle_menu(i) : location_href(arr.href)">

                <img class="navigation-bar__item--icon" :src="arr.image_src" />
                <span class="navigation-bar__item--acronym">{{arr.acronym}}</span>
                <!-- Inicio Submenú -->
                <div class="navigation-bar__item--suboptions" :class="'navigation-bar__item--suboptions-' + arr.acronym.toLowerCase()" v-if="arr.children.length">
                    <h2 class="navigation-bar__item--suboptions-title" v-html="arr.name" />
                    <span v-for="(item, j) in arr.children" :key="j">
                        <a class="navigation-bar__item--suboptions-link" :href="item.href" v-html="item.name" @click="redirect_to($event)" />
                    </span>
                </div>
                <!-- Fin Submenú -->
            </li>

            <li class="navigation-bar__item" @click="logout()">
                <img class="navigation-bar__item--icon" src="/assets/img/svg/off.svg" alt />
                <span class="navigation-bar__item--acronym">Logout</span>
            </li>

        </ul>
    </div>

</aside>
</template>

<script>
import api_routes from "./api_routes.js"
import eventBus from '@/plugins/eventBus'
import { connectSocket, disconnectSocket } from '../../plugins/socket';

export default {
    name: "MenuBar",

    props: [
        "global_route"
    ],

    data() {
        return {
            api_routes: [],
            route_definition: {},
        };
    },

    methods: {
        toggle_menu(index) {
            this.route_definition = this.api_routes[index].children
            // console.log([index, this.route_definition])
            //   window.$(`#menu${index}`).css("display") === "block" 
            //     ? window.$("#menu").css("display", "none")
            //     : window.$("#menu").css("display", "block")

        },

        logout() {
            this.$router.push('/logout')
        },

        location_href(href) {
            window.location = href

        },

        redirect_to(event) {
            if (this.$route.path.includes('assignment-daily-assignment-complete')) {
                event.preventDefault()
                eventBus.$emit('redirectTo', event.target.href)
            }
        },

        calculateMarginTop(index) {
            let margin;

            console.log(index)

            if (index > 8) {
                margin = { 'marginTop': '-320.033px' }

            }

            return margin
        },
        isActive(id) {

            console.log(this.$route)
            if (this.$route.meta?.group_id == id) {
                console.log('isActive')
                console.log(this.$route.meta?.group_id)
                console.log(id)
            }

        }

    },

    mounted() {
        this.api_routes = api_routes
        let routes = localStorage.getItem('routes');
        if (routes && routes != 'undefined') {
            this.api_routes = JSON.parse(localStorage.getItem('routes'))

        }

        this.getWithoutAwait('general_functions/routes').then((res) => {
            if (res.status) 
            {
                connectSocket(res.data.user)
                this.api_routes = res.data.routes
                localStorage.setItem('routes', JSON.stringify(this.api_routes))

                let user = this.get_user();
                this.permissions = res.data.permissions

                if (JSON.stringify((user.permissions) ? user.permissions : []) !== JSON.stringify(this.permissions)) {
                    user.permissions = this.permissions
                    localStorage.setItem('user', JSON.stringify(user))
                    location.reload()
                }
            }
        })

        window.$('.itemSide').removeClass('active')
    },
    beforeDestroy() 
    {
        disconnectSocket();
    },
};
</script>
